import { Component, OnInit, PLATFORM_ID, Inject, Renderer2, ViewChild, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { Router, NavigationEnd, ActivatedRoute, NavigationStart } from '@angular/router';
import { CommonModule, Location, isPlatformBrowser, isPlatformServer, DOCUMENT } from '@angular/common';
import { Title, Meta } from '@angular/platform-browser';
import { app_web_view_list } from './const-variables';
import { ReferralCodeService } from '../app/services/ReferralCode.service';
import { RouterOutlet } from '@angular/router';
import * as globalConstant from './global_constant';
import { HeaderComponent } from './components/header/header.component';
import { FooterComponent } from './components/footer/footer.component';
import { CanonicalService } from './services/canonical.service';
import FingerprintJS from '@fingerprintjs/fingerprintjs';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { SharedModule } from './share/shared.module';
import { PageSectionService } from './services/PageSection.service';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { InfluencerService } from './services/influencer.service';
import { CoupanService } from './services/coupan.service';
import { ToastrService } from './services/toastr.service';
import { NgxIntlTelInputModule, SearchCountryField, CountryISO, PhoneNumberFormat } from 'ngx-intl-tel-input';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

declare var $: any;
declare var pintrk: any;
declare var document: any;
declare const gtag: Function;


@Component({
	selector: 'app-root',
	standalone: true,
	imports: [SharedModule, RouterOutlet, CommonModule, HeaderComponent, FooterComponent, NgxIntlTelInputModule],
	templateUrl: './app.component.html',
	styleUrl: './app.component.css',
	schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class AppComponent implements OnInit {
	title = 'Spur Experiences';
	isBrowser: boolean;
	isServer: boolean;
	segment1: string = '';
	app_web_view_list = app_web_view_list;
	currenturl = '';
	fbclid: string = '';
	utm_source: any = '';
	utm_medium: any = '';
	utm_campaign: any = '';
	isCookies: any = true
	isHomePage: boolean = false;
	utm_parameters: any = {};
	utm_term: any = '';
	utm_content: any = '';
	isLive: any = globalConstant?.IS_LIVE;
	siteUrl: String = globalConstant?.WEBSITE_URL;
	displayAcceptCookies: boolean = false;
	influencerName: string = '';
	visitorId: string | null = null;
	authUser: any;
	@ViewChild('agreeTermsModal', { static: false }) public agreeTermsModal: ModalDirective;
	blockUI: boolean = false;
	influencerTerms: any = [];
	safeHtml: SafeHtml;
	tokenKey: any;

	@ViewChild('signupModal', { static: false }) public signupModal: ModalDirective;
	signUpForm: FormGroup;
	email_space_error = false;
	submitted: boolean = false;
	invalid_email: any = false;
	selectedCountry: string = 'us';

	separateDialCode = true;
	SearchCountryField = SearchCountryField;
	CountryISO = CountryISO;
	preferredCountries: CountryISO[] = [CountryISO.UnitedStates];

	@ViewChild('coupanModal', { static: false }) public coupanModal: ModalDirective;
	coupanData: any;
	copyMessage = '';
	showCopyMessage = false;
	coupanEndDate: any;
	routeUrl: string = '';

	constructor(
		private router: Router,
		private activatedRoute: ActivatedRoute,
		private location: Location,
		private referralCodeService: ReferralCodeService,
		private metaService: Meta,
		public renderer: Renderer2,
		private canonicalService: CanonicalService,
		public pageSectionService: PageSectionService,
		private sanitizer: DomSanitizer,
		public influencerService: InfluencerService,
		public coupanService: CoupanService,
		public toastr: ToastrService,
		private formBuilder: FormBuilder,
		@Inject(DOCUMENT) document1: any,
		@Inject(PLATFORM_ID) platformId: Object
	) {

		this.isBrowser = isPlatformBrowser(platformId);
		this.isServer = isPlatformServer(platformId);

		if (this.isBrowser) {
			let isBoat = this.isSitePerformanceBoat();
			if (!isBoat) {
				// Load External Css files............................
				const facebookingConnectCss = this.loadExternalCss(this.renderer, "https://connect.facebook.net");
				const googleMapsCss = this.loadExternalCss(this.renderer, "https://maps.googleapis.com");
				const googleStorageCss = this.loadExternalCss(this.renderer, "https://storage.googleapis.com");

				// Load External Script files.....................
				const lazysizesScriptLoad = this.loadJsScript(this.renderer, "https://assets.spurexperiences.com/assets/js/lazysizes.min.js");
				//const msClarityScriptLoad = this.loadJsScript(this.renderer, "https://www.clarity.ms/tag/ifpvpw24xu");
				const googleScriptLoad = this.loadJsScript(this.renderer, "https://apis.google.com/js/platform.js", true, true);
				const appleScriptLoad = this.loadJsScript(this.renderer, "https://appleid.cdn-apple.com/appleauth/static/jsapi/appleid/1/en_US/appleid.auth.js");

				// this.addGTMScript('GTM-M45RVLC');
				this.loadGoogleTagManagerScript();
				this.loadGoogleTagManagerScript2();
				this.loadSnapEngageScript();
				this.loadPinterestTrackingScript();
				this.loadFacebookPixel();
				this.loadGoogleRemarketingScript();
				// this.loadClarityScript();
				this.loadTikTokPixel();
				this.getDeviceId();
				// this.loadKlaviyoScripts();
			}
			this.initializeAuthData();
		}

		this.activatedRoute?.queryParams.subscribe(params => {
			this.utm_parameters = params;
			if (params['utm_source'] || params['fbclid'] && this.isBrowser) {

				if (params['utm_source']) {
					if (params['utm_campaign'] === 'influencer') {
						this.influencerName = params['utm_source'];
						sessionStorage.setItem('influencerData', this.influencerName);
						this.getDeviceId();
					} else {
						this.utm_source = params['utm_source'];
					}
				} else if (params['fbclid']) {
					this.fbclid = params['fbclid'];
					this.utm_source = 'facebook';
				} else if (document.referrer == 'https://l.facebook.com/') {
					this.fbclid = 'https://l.facebook.com/';
					this.utm_source = 'facebook';
				}

				if (params['utm_medium']) {
					this.utm_medium = params['utm_medium'];
				} else {
					this.utm_medium = '';
				} if (params['utm_campaign']) {
					this.utm_campaign = params['utm_campaign'];
				} else {
					this.utm_campaign = '';
				} if (params['utm_term']) {
					this.utm_term = params['utm_term']
				} else {
					this.utm_term = '';
				} if (params['utm_content']) {
					this.utm_content = params['utm_content'];
				} else {
					this.utm_content = '';
				}

				let utm_campaign_check
				let utm_source_check

				if (localStorage.getItem('referal_code_parameters')) {
					let logData = JSON.parse(localStorage.getItem('referal_code_parameters'))
					utm_source_check = logData?.utm_source
					utm_campaign_check = logData?.utm_campaign
				}
				if (utm_campaign_check != this.utm_campaign || this.utm_source != utm_source_check) {

					let requestBody = { 'utm_source': this.utm_source, 'fbclid': this.fbclid, 'utm_medium': this.utm_medium, 'utm_campaign': this.utm_campaign, 'utm_term': this.utm_term, 'utm_content': this.utm_content };
					localStorage.setItem('referal_code_parameters', JSON.stringify(requestBody));

					this.referralCodeService.saveReferralSource(requestBody).subscribe();
					utm_campaign_check = this.utm_campaign
					utm_source_check = this.utm_source
				}
				// this.addMetaTags();
			}
		});

		const currentPath = this.location.path();
		const current = currentPath.split('?')[0];
		this.routeUrl = current;

		if (currentPath === '/' || currentPath == '') {
			this.isHomePage = true;
		}
	}

	async getDeviceId(): Promise<string | null> {
		if (this.isBrowser) {
			if (this.visitorId) return this.visitorId;

			const stored = localStorage.getItem('device-id');
			if (stored) {
				this.visitorId = stored;
				return stored;
			}

			const fp = await FingerprintJS.load();
			const result = await fp.get();
			this.visitorId = result.visitorId;
			localStorage.setItem('device-id', this.visitorId);
			if (this.influencerName !== '' && this.isBrowser) {
				const hasTrackedKey = `influencer-tracked-${this.influencerName}`;
				const alreadyTracked = localStorage.getItem(hasTrackedKey);

				if (!alreadyTracked && this.visitorId) {
					const requestBody = {
						source_value: this.visitorId,
						source_type: 'web_device_id',
						influencer_username: this.influencerName,
					};

					this.referralCodeService.influencerReferralLog(requestBody).subscribe(() => {
						localStorage.setItem(hasTrackedKey, 'true');
					});
				}
			}
			return this.visitorId;
		}

	}

	normalizeUrl(url: string): string {
		return url.endsWith('/') ? url.slice(0, -1) : url; // Remove trailing slash if present
	}

	ngOnInit() {
		this.signUpForm = this.formBuilder.group({
			user_email: ['', [Validators.required]],
			user_phone: [[], [Validators.required]],
		});

		this.router?.events.subscribe(event => {
			if (event instanceof NavigationEnd) {
				var urlObj = this.router?.url?.split('/');

				if (urlObj[1]) {
					this.segment1 = this.router?.url?.split('/')[1];
				}
				if (this.isBrowser) {
					if (((this.segment1 !== undefined && this.segment1 !== null && this.segment1 !== '') &&
						(this.segment1 == 'registry' || this.segment1 == 'experiences' ||
							this.segment1 == 'ticket-map-web-view')) || (this.routeUrl == "/ticket-map-web-view")) {
						this.displayAcceptCookies = false;
					} else {
						this.displayAcceptCookies = true;
					}
				}
				if (urlObj[1] !== "experience-provider-add") {
					if (this.isBrowser) {

						localStorage.removeItem('exp-provider-add')
					}
				}
				if (this.router?.url?.split('/')[1]) {
					if (this.router?.url?.split('/')[1]?.split('?')[0]) {
						this.currenturl = this.router?.url?.split('/')[1]?.split('?')[0];
					} else {
						this.currenturl = this.router?.url?.split('/')[1];
					}
				}
			}
		});
		const canonicalUrl = this.normalizeUrl(this.siteUrl + this.router.url);
		this.canonicalService.setCanonical(canonicalUrl);

		if (this.isLive) {
			this.load_pinterest_script();
		}

		this.getContentHeight();
		if (this.isBrowser) {

			this.isCookies = document?.cookie.split(';')
		}
		this.checkCookie();

	}

	get user() {
		return this.signUpForm?.controls;
	}

	getAuthToken() {
		if (this.isBrowser) {
			if (localStorage.getItem('login_token')) {
				this.tokenKey = localStorage.getItem('login_token');
			} else {
				setTimeout(() => {
					if (this.routeUrl !== "/ticket-map-web-view") {
						let displayCoupan = localStorage?.getItem('DisplayedCoupanOffer')
						if (localStorage.getItem('login_token')) {
							this.tokenKey = localStorage.getItem('login_token');
						}
						if (!displayCoupan && !this.tokenKey) {
							if (localStorage?.getItem('CoupanCode')) {
								let added = JSON.parse(localStorage.getItem('CoupanCode'));
								if (!added) {
									this.signupModal?.show();
								}
							} else {
								this.signupModal?.show();
							}
						}
					}
				}, 45000)
			}
		}
	}

	initializeAuthData() {
		if (this.isBrowser) {
			this.referralCodeService.authUser$.subscribe(user => {
				this.authUser = user;
				let requestBody = { 'slug': "influencer-terms-conditions" };
				this.pageSectionService.get_page_data(requestBody).subscribe(res => {
					if (res.response == "success") {
						this.getAuthToken();
						this.influencerTerms = res?.data;
						if (this.influencerTerms?.body) {
							this.safeHtml = this.sanitizer.bypassSecurityTrustHtml(this.influencerTerms.body);
						}
						if (this.safeHtml && user?.is_influencer && user?.is_influencer_agreed_terms == 0) {
							setTimeout(() => {
								this.agreeTermsModal?.show();
								this.blockUI = true;
							}, 1000);
						}
					}
				});

			});

			const storedUser = this.referralCodeService.getAuthUser();
			if (storedUser) {
				this.referralCodeService.setAuthUser(storedUser);
			}
		}
	}

	setCookie(cname, cvalue, exdays) {
		const d = new Date();
		d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
		let expires = "expires=" + d.toUTCString();
		document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
		this.isCookies = true;

		localStorage.setItem("acceptCookies", "yes");
	}

	checkCookie() {
		let cart = this.getCookie("acceptCookies");
		if (cart != "") {
			this.isCookies = true
		} else {
			this.isCookies = false
			if (cart != "" && cart != null) {
				this.setCookie("acceptCookies", cart, 365);
			}
		}
	}

	getCookie(data) {
		if (this.isBrowser) {

			let name = data + "=";
			let ca = document.cookie.split(';');
			for (let i = 0; i < ca.length; i++) {
				let c = ca[i];
				while (c.charAt(0) == ' ') {
					c = c.substring(1);
				}
				if (c.indexOf(name) == 0) {
					return c.substring(name.length, c.length);
				}
			}
			return "";
		}
	}

	isSitePerformanceBoat(): boolean {
		const userAgent = window.navigator.userAgent;
		if (userAgent.includes('GTmetrix') || userAgent.includes('Chrome-Lighthouse')) {
			return true;
		}
		return false;
	}

	loadGoogleTagManagerScript(): void {
		// Add the gtag.js script
		const script = this.renderer.createElement('script');
		this.renderer.setAttribute(script, 'src', 'https://www.googletagmanager.com/gtag/js?id=AW-10805683766');
		this.renderer.setAttribute(script, 'async', '');
		this.renderer.appendChild(document.head, script);

		// Add the gtag initialization script
		const initScript = this.renderer.createElement('script');
		initScript.text = `
			window.dataLayer = window.dataLayer || [];
			function gtag() { dataLayer.push(arguments); }
			gtag('js', new Date());
			gtag('config', 'AW-10805683766');
		`;
		this.renderer.appendChild(document.head, initScript);
	}

	loadGoogleTagManagerScript2(): void {
		// Add the gtag.js script
		const script = this.renderer.createElement('script');
		this.renderer.setAttribute(script, 'src', 'https://www.googletagmanager.com/gtag/js?id=G-0ZTFKH1LYK');
		this.renderer.setAttribute(script, 'async', '');
		this.renderer.appendChild(document.head, script);

		// Add the gtag initialization script
		const initScript = this.renderer.createElement('script');
		initScript.text = `
			window.dataLayer = window.dataLayer || [];
			function gtag() { dataLayer.push(arguments); }
			gtag('js', new Date());
			gtag('config', 'G-0ZTFKH1LYK');
		`;
		this.renderer.appendChild(document.head, initScript);
	}


	loadKlaviyoScripts() {
		// Load the async script
		const asyncScript = this.renderer.createElement('script');
		asyncScript.type = 'text/javascript';
		asyncScript.src = 'https://static.klaviyo.com/onsite/js/Ti3S72/klaviyo.js?company_id=Ti3S72';
		asyncScript.async = true;
		this.renderer.appendChild(document.head, asyncScript);

		// Load the initialization script
		const initScript = this.renderer.createElement('script');
		initScript.type = 'text/javascript';
		initScript.text = `!function(){if(!window.klaviyo){window._klOnsite=window._klOnsite||[];try{window.klaviyo=new Proxy({},{get:function(n,i){return"push"===i?function(){var n;(n=window._klOnsite).push.apply(n,arguments)}:function(){for(var n=arguments.length,o=new Array(n),w=0;w<n;w++)o[w]=arguments[w];var t="function"==typeof o[o.length-1]?o.pop():void 0,e=new Promise((function(n){window._klOnsite.push([i].concat(o,[function(i){t&&t(i),n(i)}]))}));return e}}})}catch(n){window.klaviyo=window.klaviyo||[],window.klaviyo.push=function(){var n;(n=window._klOnsite).push.apply(n,arguments)}}}}();`;
		this.renderer.appendChild(document.head, initScript);
	}

	loadSnapEngageScript(): void {
		const script = this.renderer.createElement('script');
		this.renderer.setAttribute(script, 'type', 'text/javascript');
		this.renderer.setAttribute(script, 'async', '');
		this.renderer.setAttribute(script, 'defer', '');
		this.renderer.setAttribute(
			script,
			'src',
			'//storage.googleapis.com/code.snapengage.com/js/794d2fd0-e8b6-4835-90dd-f1b5bbf04614.js'
		);

		script.onload = () => {
			console.log('SnapEngage script loaded.');
			// Place your SnapEngage JS API code below
			// Example: SnapEngage.allowChatSound(true); 
		};

		script.onerror = () => {
			console.error('Failed to load the SnapEngage script.');
		};

		// Append the script to the head or body
		const firstScript = document.getElementsByTagName('script')[0];
		this.renderer.appendChild(firstScript.parentNode, script);
	}

	loadPinterestTrackingScript(): void {
		// Add the Pinterest script
		const pinterestScript = this.renderer.createElement('script');
		this.renderer.setAttribute(pinterestScript, 'type', 'text/javascript');
		pinterestScript.text = `
		  !function (e) {
			if (!window.pintrk) {
			  window.pintrk = function () {
				window.pintrk.queue.push(Array.prototype.slice.call(arguments))
			  };
			  var n = window.pintrk;
			  n.queue = [], n.version = "3.0";
			  var t = document.createElement("script");
			  t.async = !0, t.src = e;
			  var r = document.getElementsByTagName("script")[0];
			  r.parentNode.insertBefore(t, r)
			}
		  }("https://s.pinimg.com/ct/core.js");
		  pintrk('load', '2619018219672');
		`;
		this.renderer.appendChild(document.head, pinterestScript);

		// Add the noscript element
		const noscript = this.renderer.createElement('noscript');
		const img = this.renderer.createElement('img');
		this.renderer.setAttribute(img, 'src', 'https://ct.pinterest.com/v3/?tid=2619018219672&noscript=1');
		this.renderer.setAttribute(img, 'height', '1');
		this.renderer.setAttribute(img, 'width', '1');
		this.renderer.setAttribute(img, 'style', 'display:none;visibility:hidden');
		this.renderer.appendChild(noscript, img);
		this.renderer.appendChild(document.body, noscript);
	}

	loadFacebookPixel(): void {
		// Add the Facebook Pixel script
		const facebookScript = this.renderer.createElement('script');
		facebookScript.type = 'text/javascript';
		facebookScript.text = `
		  !function (f, b, e, v, n, t, s) {
			if (f.fbq) return;
			n = f.fbq = function () {
			  n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments)
			};
			if (!f._fbq) f._fbq = n;
			n.push = n;
			n.loaded = !0;
			n.version = '2.0';
			n.queue = [];
			t = b.createElement(e);
			t.async = !0;
			t.src = v;
			s = b.getElementsByTagName(e)[0];
			s.parentNode.insertBefore(t, s)
		  }(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
		  fbq('init', '1049718878423156');
		  fbq('track', 'PageView');
		`;
		this.renderer.appendChild(document.head, facebookScript);

		// Add the noscript fallback
		const noscript = this.renderer.createElement('noscript');
		const img = this.renderer.createElement('img');
		this.renderer.setAttribute(img, 'src', 'https://www.facebook.com/tr?id=1049718878423156&ev=PageView&noscript=1');
		this.renderer.setAttribute(img, 'height', '1');
		this.renderer.setAttribute(img, 'width', '1');
		this.renderer.setAttribute(img, 'style', 'display:none;visibility:hidden');
		this.renderer.appendChild(noscript, img);
		this.renderer.appendChild(document.body, noscript);
	}

	loadGoogleRemarketingScript(): void {
		// Add the Google remarketing script
		const googleScript = this.renderer.createElement('script');
		this.renderer.setAttribute(googleScript, 'type', 'text/javascript');
		this.renderer.setAttribute(googleScript, 'src', '//www.googleadservices.com/pagead/conversion_async.js');
		this.renderer.appendChild(document.body, googleScript);

		// Add the noscript fallback
		const noscript = this.renderer.createElement('noscript');
		const div = this.renderer.createElement('div');
		this.renderer.setAttribute(div, 'style', 'display:inline;');

		const img = this.renderer.createElement('img');
		this.renderer.setAttribute(
			img,
			'src',
			'//googleads.g.doubleclick.net/pagead/viewthroughconversion/971177656/?value=0&amp;guid=ON&amp;script=0'
		);
		this.renderer.setAttribute(img, 'height', '1');
		this.renderer.setAttribute(img, 'width', '1');
		this.renderer.setAttribute(img, 'style', 'border-style:none;');

		this.renderer.appendChild(div, img);
		this.renderer.appendChild(noscript, div);
		this.renderer.appendChild(document.body, noscript);
	}

	loadTikTokPixel(): void {
		// Define TikTok pixel initialization function
		const initTikTokPixel = `
		  (function (w, d, t) {
			w.TiktokAnalyticsObject = t;
			var ttq = w[t] = w[t] || [];
			ttq.methods = ["page", "track", "identify", "instances", "debug", "on", "off", "once", "ready", "alias",
			  "group", "enableCookie", "disableCookie"];
			ttq.setAndDefer = function (t, e) {
			  t[e] = function () {
				t.push([e].concat(Array.prototype.slice.call(arguments, 0)))
			  };
			};
			for (var i = 0; i < ttq.methods.length; i++) ttq.setAndDefer(ttq, ttq.methods[i]);
			ttq.instance = function (t) {
			  for (var e = ttq._i[t] || [], n = 0; n < ttq.methods.length; n++) ttq.setAndDefer(e, ttq.methods[n]);
			  return e;
			};
			ttq.load = function (e, n) {
			  var i = "https://analytics.tiktok.com/i18n/pixel/events.js";
			  ttq._i = ttq._i || {}, ttq._i[e] = [], ttq._i[e]._u = i, ttq._t = ttq._t || {}, ttq._t[e] = +new Date;
			  ttq._o = ttq._o || {}, ttq._o[e] = n || {};
			  var o = d.createElement("script");
			  o.type = "text/javascript", o.async = true, o.src = i + "?sdkid=" + e + "&lib=" + t;
			  var a = d.getElementsByTagName("script")[0];
			  a.parentNode.insertBefore(o, a);
			};
			ttq.load('CFHVP1JC77UCCRP96PU0');
			ttq.page();
		  })(window, document, 'ttq');`;

		// Create and append the script element
		const script = this.renderer.createElement('script');
		this.renderer.setAttribute(script, 'type', 'text/javascript');
		script.text = initTikTokPixel;
		this.renderer.appendChild(document.body, script);
	}

	addGTMScript(gtmId: string) {
		const script = this.renderer.createElement('script');
		script.type = 'text/javascript';
		script.async = true;
		script.text = `
			(function (w, d, s, l, i) {
				w[l] = w[l] || []; w[l].push({
				'gtm.start':
					new Date().getTime(), event: 'gtm.js'
				}); 
				var f = d.getElementsByTagName(s)[0],
					j = d.createElement(s),
					dl = l != 'dataLayer' ? '&l=' + l : '';
				j.async = true;
				j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
				f.parentNode.insertBefore(j, f);
			})(window, document, 'script', 'dataLayer', '${gtmId}');
		`;
		this.renderer.appendChild(document.head, script);


		const script2 = this.renderer.createElement('script');
		script2.type = 'text/javascript';
		script2.async = true;
		script2.src = `https://www.googletagmanager.com/gtag/js?id=${gtmId}`;
		this.renderer.appendChild(document.head, script2);

		// Add the GTAG initialization script
		const inlineScript = this.renderer.createElement('script');
		inlineScript.type = 'text/javascript';
		inlineScript.text = `
		window.dataLayer = window.dataLayer || [];
		function gtag() { dataLayer.push(arguments); }
		gtag('js', new Date());
		gtag('config', '${gtmId}');
		`;
		this.renderer.appendChild(document.head, inlineScript);

	}

	public loadClarityScript(): void {
		// Check if the script is already loaded to avoid duplicates
		if (document.getElementById('clarity-script')) {
			return;
		}

		// Create the script element
		const script = document.createElement('script');
		script.id = 'clarity-script';
		script.async = true;
		script.src = 'https://www.clarity.ms/tag/ifpvpw24xu';

		// Append the script to the document's head
		document.head.appendChild(script);

		// Initialize Clarity
		(window as any).clarity =
			(window as any).clarity ||
			function () {
				((window as any).clarity.q = (window as any).clarity.q || []).push(arguments);
			};
	}

	public loadJsScript(renderer: Renderer2, src: string, isAsync: boolean = false, isDefer: boolean = false): HTMLScriptElement {
		const script = renderer.createElement('script');
		script.type = 'text/javascript';
		script.src = src;
		if (isAsync) {
			script.async = true;
		}
		if (isDefer) {
			script.defer = true;
		}
		renderer.appendChild(document.body, script);
		return script;
	}

	public loadExternalCss(renderer: Renderer2, href: string): HTMLScriptElement {
		const link = renderer.createElement('link');
		link.rel = 'dns-prefetch';
		link.href = href;
		renderer.appendChild(document.head, link);
		return link;
	}

	addMetaTags() {
		let iosAffliatedData = JSON.stringify(this.utm_parameters);
		let appArguments = iosAffliatedData;

		let iosMetaContent = 'app-id=1123434344,affiliate-data=' + iosAffliatedData + ',app-argument=https://www.spurexperiences.com?utm_source=google';
		this.metaService.updateTag({ name: 'apple-itunes-app', content: iosMetaContent });

	}

	onResize(event) {
		this.getContentHeight();
	}

	load_pinterest_script() {
		if (this.isBrowser) {

			pintrk('track', 'pagevisit');
		}
	}

	getContentHeight() {
		if (this.isBrowser && document.documentElement && document.getElementById("header") && document.getElementById("footer") && document.getElementById("body-content-wrapper")) {
			var wndowHeight = document.documentElement.clientHeight,
				mainHeader = document.getElementById("header").clientHeight,
				mainFooter = document.getElementById("footer").clientHeight,
				veboWrapper = document.getElementById("body-content-wrapper")

			veboWrapper.style.minHeight = wndowHeight - (mainHeader + mainFooter) + "px";
		}

	}

	closeCookies() {
		this.isCookies = true
	}

	inflencerAgreeTermsAndConditions() {
		let requestbody = {};
		this.influencerService.inflencerAgreeTermsAndConditions(requestbody, this.tokenKey).subscribe(res => {
			if (res?.response === 'success') {
				let authUserData = JSON.parse(localStorage.getItem('authUser'));
				authUserData.is_influencer_agreed_terms = 1;
				localStorage.setItem('authUser', JSON.stringify(authUserData));
				this.closeAgreeTermsModal();
			} else {
				// error response
				this.toastr.errorToastr("Something went wrong!", 'Error!');
			}
		});
	}

	closeAgreeTermsModal() {
		this.agreeTermsModal.hide();
		this.blockUI = false;
	}

	closePopup(): void {
		this.signupModal.hide();
		localStorage.setItem('DisplayedCoupanOffer', 'true');
	}

	closeThankyouPopup() {
		this.coupanModal.hide();
	}

	check_email_format(event) {
		if (event?.target?.value?.split(/\s/)?.join('') != "") {
			this.email_space_error = false;
			if (this.isEmail(event?.target?.value?.replace(/^\s+|\s+$/gm, ''))) {
				this.invalid_email = false;
			}
			else {
				this.invalid_email = true;
			}
		} else {
			if (this.submitted) {
				this.email_space_error = true;
			}
			this.invalid_email = false;
		}
	}

	isEmail(email) {
		var regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
		return regex.test(email);
	}

	onCountryChange(event: any) {
		this.selectedCountry = event?.iso2;
	}

	formatPhoneNumber(event: any): void {
		if (this.selectedCountry === 'us') {
			const input = event?.target?.value.replace(/\D/g, '');
			if (input.length > 0) {
				let formatted = '';
				if (input.length <= 3) {
					formatted = `(${input}`;
				} else if (input.length <= 6) {
					formatted = `(${input.slice(0, 3)}) ${input.slice(3)}`;
				} else {
					formatted = `(${input.slice(0, 3)}) ${input.slice(3, 6)}-${input.slice(6, 10)}`;
				}
				this.signUpForm.controls['user_phone'].setValue(formatted, { emitEvent: false });
			}
		}
	}

	onSubmit(): void {
		this.submitted = true;
		if (this.signUpForm.invalid || this.signUpForm?.get('user_email')?.value?.split(/\s/)?.join('') == "" || this.invalid_email) {
			if (this.signUpForm?.get('user_email')?.value?.split(/\s/)?.join('') == "") {
				this.email_space_error = true;
			}
			else {
				this.email_space_error = false;
			}
			return;
		} else {
			this.email_space_error = false;
		}
		let requestBody = {
			'email': this.signUpForm.get('user_email').value.replace(/^\s+|\s+$/gm, ''),
			'phone_json': this.signUpForm.get('user_phone').value,
		}
		this.coupanService.saveVisitorData(requestBody).subscribe(res => {
			if (res?.response == "success") {
				if (res?.data) {
					this.coupanData = res?.data;
					this.coupanEndDate = this.formatDate(this.coupanData?.end_date)
					if (this.isBrowser) {
						localStorage.setItem('CoupanCode', JSON.stringify(this.coupanData));
						localStorage.setItem('DisplayedCoupanOffer', 'true');
					}
					this.closePopup();
					this.coupanModal?.show();
				}
			} else {
				this.submitted = false;
				this.toastr.errorToastr(res.message, 'Error!');
			}
		});
	}

	async copyCouponCode(): Promise<void> {
		try {
			if (this.coupanData?.coupon_number) {
				await navigator.clipboard.writeText(this.coupanData.coupon_number);
				this.showCopySuccess();
			}
		} catch (err) {
			// Fallback for older browsers or when clipboard API fails
			this.fallbackCopyTextToClipboard(this.coupanData?.coupon_number || '');
		}
	}

	fallbackCopyTextToClipboard(text: string): void {
		const textArea = document.createElement('textarea');
		textArea.value = text;
		textArea.style.top = '0';
		textArea.style.left = '0';
		textArea.style.position = 'fixed';

		document.body.appendChild(textArea);
		textArea.focus();
		textArea.select();

		try {
			const successful = document.execCommand('copy');
			if (successful) {
				this.showCopySuccess();
			} else {
				this.showCopyError();
			}
		} catch (err) {
			this.showCopyError();
		}

		document.body.removeChild(textArea);
	}

	showCopySuccess() {
		this.copyMessage = 'Coupon code copied!';
		this.showCopyMessage = true;
		setTimeout(() => {
			this.showCopyMessage = false;
		}, 4000);
	}

	showCopyError() {
		this.copyMessage = 'Failed to copy coupon code';
		this.showCopyMessage = true;
		setTimeout(() => {
			this.showCopyMessage = false;
		}, 2000);
	}

	parseDateToObject(dateStr) {
		let date = new Date(dateStr)
		return new Date(date.toISOString().slice(0, -1));
	}

	formatDate(str) {
		const date = this.parseDateToObject(str);

		const day = date.getDate();
		const month = date.toLocaleString('default', { month: 'long' });
		const year = date.getFullYear();

		const ordinalSuffix = (day: number) => {
			if (day > 3 && day < 21) return 'th';
			switch (day % 10) {
				case 1: return 'st';
				case 2: return 'nd';
				case 3: return 'rd';
				default: return 'th';
			}
		};

		return `${month} ${day}${ordinalSuffix(day)}, ${year}`;
	}
}
